import React from 'react';

export const emptyCostTotals = () => ({costs: [], costedShifts: 0, missingCostShifts: 0});

export const addShiftCost = (totals, shift) => {
  const cost = shift.plandayCost;
  if (typeof cost?.amount !== 'number' || !Number.isFinite(cost.amount)) {
    totals.missingCostShifts++;
    return;
  }
  totals.costedShifts++;
  const currencySymbol = cost.currencySymbol || '';
  let entry = totals.costs.find(value => value.currencySymbol === currencySymbol);
  if (!entry) { entry = {currencySymbol, amount: 0}; totals.costs.push(entry); }
  entry.amount += cost.amount;
};

export default function RotaCostTotal({totals}) {
  const costs = totals.costs || [];
  const count = (totals.costedShifts || 0) + (totals.missingCostShifts || 0);
  return <span title={`Costs available for ${totals.costedShifts || 0} of ${count} shifts`}>
    / {costs.length ? costs.map(cost => `${cost.currencySymbol}${cost.amount.toLocaleString('en-GB', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    })}${cost.currencySymbol ? '' : ' (currency unspecified)'}`).join(' · ') : 'Unavailable'}
    {costs.length > 0 && totals.missingCostShifts > 0 && <small> (partial)</small>}
  </span>;
}
